import { handleActions } from 'redux-actions';
import types from './types';
import { mergeIn } from '../../../../helpers/stateHelpers';

const reducers = handleActions({
  [types.SET_PENDING_STATUS]: mergeIn(action => action.payload),
}, null);

export default reducers;
